import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { SelectScrollArea } from '../SelectScrollArea/SelectScrollArea.js';
import { Popover } from '../../Popover/Popover.js';
import { Overlay, Box } from '@mantine/core';
import useStyles from './SelectPopover.styles.js';

var _excluded = ["children", "component", "maxHeight", "direction", "id", "innerRef", "__staticSelector", "styles", "classNames", "unstyled", "topSection", "dropdownRef", "handleClickOverlay", "withOverlay"];
function SelectPopoverDropdown(_ref) {
  var children = _ref.children,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'div' : _ref$component,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? 220 : _ref$maxHeight,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'column' : _ref$direction,
    id = _ref.id,
    innerRef = _ref.innerRef,
    __staticSelector = _ref.__staticSelector,
    styles = _ref.styles,
    classNames = _ref.classNames,
    unstyled = _ref.unstyled,
    topSection = _ref.topSection,
    dropdownRef = _ref.dropdownRef,
    handleClickOverlay = _ref.handleClickOverlay,
    _ref$withOverlay = _ref.withOverlay,
    withOverlay = _ref$withOverlay === void 0 ? false : _ref$withOverlay,
    others = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(undefined, {
      name: __staticSelector,
      styles: styles,
      classNames: classNames,
      unstyled: unstyled
    }),
    classes = _useStyles.classes;
  return /*#__PURE__*/React__default.createElement(Popover.Dropdown, _objectSpread2({
    p: 0,
    onMouseDown: function onMouseDown(event) {
      return event.preventDefault();
    }
  }, others), withOverlay ? ( /*#__PURE__*/React__default.createElement(Overlay, {
    zIndex: -1,
    opacity: 0,
    style: {
      position: 'fixed'
    },
    onClick: handleClickOverlay,
    onTouchStart: function onTouchStart(e) {
      return e.stopPropagation();
    }
  })) : null, /*#__PURE__*/React__default.createElement("div", {
    ref: dropdownRef
  }, topSection, /*#__PURE__*/React__default.createElement("div", {
    style: {
      maxHeight: maxHeight,
      display: 'flex'
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    component: component || 'div',
    id: "".concat(id, "-items"),
    "aria-labelledby": "".concat(id, "-label"),
    role: "listbox",
    onMouseDown: function onMouseDown(event) {
      return event.preventDefault();
    },
    style: {
      flex: 1,
      overflowY: component !== SelectScrollArea ? 'auto' : undefined
    },
    "data-combobox-popover": true,
    ref: innerRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.itemsWrapper,
    style: {
      flexDirection: direction
    }
  }, children)))));
}
function SelectPopover(_ref2) {
  var opened = _ref2.opened,
    _ref2$transition = _ref2.transition,
    transition = _ref2$transition === void 0 ? 'fade' : _ref2$transition,
    _ref2$transitionDurat = _ref2.transitionDuration,
    transitionDuration = _ref2$transitionDurat === void 0 ? 0 : _ref2$transitionDurat,
    shadow = _ref2.shadow,
    withinPortal = _ref2.withinPortal,
    children = _ref2.children,
    __staticSelector = _ref2.__staticSelector,
    onDirectionChange = _ref2.onDirectionChange,
    switchDirectionOnFlip = _ref2.switchDirectionOnFlip,
    zIndex = _ref2.zIndex,
    dropdownPosition = _ref2.dropdownPosition,
    _ref2$positionDepende = _ref2.positionDependencies,
    positionDependencies = _ref2$positionDepende === void 0 ? [] : _ref2$positionDepende,
    classNames = _ref2.classNames,
    styles = _ref2.styles,
    unstyled = _ref2.unstyled,
    readOnly = _ref2.readOnly,
    _ref2$popoverWidth = _ref2.popoverWidth,
    popoverWidth = _ref2$popoverWidth === void 0 ? 'target' : _ref2$popoverWidth,
    _ref2$popoverOffset = _ref2.popoverOffset,
    popoverOffset = _ref2$popoverOffset === void 0 ? 0 : _ref2$popoverOffset;
  return /*#__PURE__*/React__default.createElement(Popover, {
    unstyled: unstyled,
    classNames: classNames,
    styles: styles,
    width: popoverWidth,
    offset: popoverOffset,
    withRoles: false,
    opened: opened,
    middlewares: {
      flip: dropdownPosition === 'flip',
      shift: false
    },
    position: dropdownPosition === 'flip' ? 'bottom' : dropdownPosition,
    positionDependencies: positionDependencies,
    zIndex: zIndex,
    __staticSelector: __staticSelector,
    withinPortal: withinPortal,
    transition: transition,
    transitionDuration: transitionDuration,
    exitTransitionDuration: 0,
    shadow: shadow,
    disabled: readOnly,
    onPositionChange: function onPositionChange(nextPosition) {
      return switchDirectionOnFlip && (onDirectionChange === null || onDirectionChange === void 0 ? void 0 : onDirectionChange(nextPosition === 'top' ? 'column-reverse' : 'column'));
    }
  }, children);
}
SelectPopover.Target = Popover.Target;
SelectPopover.Dropdown = SelectPopoverDropdown;

export { SelectPopover };
//# sourceMappingURL=SelectPopover.js.map
